import { Injectable } from '@angular/core';
import { TokenAuthServiceProxy, AuthenticateModel, AuthenticateResultModel } from './../../../../shared/service-proxies/service-proxies';
import { MatDialog } from '@angular/material';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class Test1Service {

  constructor(
    private tokenService : TokenAuthServiceProxy
  ) { }
  

  testAlert(username: string, password:string, finallyCallback?: () => void) : void {
    let authModel : AuthenticateModel;
    authModel.userNameOrEmailAddress = username;
    authModel.password = password ;

    this.tokenService
        .authenticate(authModel)
        .pipe(
          finalize(() => {
            finallyCallback();
          }))
          .subscribe((result: AuthenticateResultModel) => {
            console.log("Login tamamdir!");
            let str = JSON.stringify(result);
            console.log(str);
          }
        );
        
  }

}
